module.exports = __webpack_public_path__ + "static/media/Handbok Dysmate-Y SE full version.3d46fd15.png";